import React from 'react';
import {Link} from "react-router-dom";
import Themes from '../themes/Themes';
import "./TopMenu.scss";

function TopMenu() {
    const contactForm = 'c5da9e21-5752-45ac-87bb-2452178ab9ff';

    return (
        <div className="top-menu">
            <Themes/>
            {/* <a className={'top-menu-icon'} target="_blank" href="https://discord.com"><div className="discord"></div></a> */}
            <Link to={{
                pathname: `/`
            }}>
                Scripts
            </Link>
            <a href="https://www.youtube.com/channel/UC_h2qb61tvGfoj9wfw22cww" target="_blank">
                Subscribe
            </a>
            <Link to={{
                pathname: `/info`
            }}>
                Info
            </Link>
            {contactForm ? <Link to={{pathname: `/contact`}}>Contact</Link> : null}
        </div>
    );
}

export default TopMenu;
